﻿// components
import QuestionHeader from './QuestionHeader'

// utils
import * as constants from '../../Utils/constants';


const PreSign = () => {

    return (
        <section className="pension-wizard-block__question">
            <div className="pension-wizard-block__question__card">
                <QuestionHeader
                    heading={constants.preSign.headline}
                    text={constants.preSign.text}
                    paragraph2={constants.preSign.paragraph2}
                    paragraph3={constants.preSign.paragraph3}
                />
                <button
                    type="submit"
                    className="button button--green">{constants.preSign.buttonText}
                </button>
            </div>
        </section>
    )
}

export default PreSign;
